import template from './search-input.html';
import _ from 'lodash';

class SearchInputController {
  constructor() {
    this.loading = false;
    this.showClear = !_.isEmpty(this.query);
  }

  searchSubmit(search) {
    this.onTrigger({ query: search });
    this.showClear = !_.isEmpty(search);
    this.query = search;
  }

  $onChanges(changes) {
    const { inValue } = changes;
    if (inValue) {
      this.query = this.inValue;
    }
  }
}

export default {
  template,
  controller: SearchInputController,
  controllerAs: 'searchInputVm',
  bindings: {
    onTrigger: '&',
    onChange: '&',
    isSearching: '<',
    placeHolder: '@',
    inValue: '<',
  },
};
